import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot";
import axios from "axios";

export const getInventorySolarPanelLookUp = createAsyncThunk("inventory/get inventory solar panel list", async () => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-inventorySolarPanel`);
    return response;
  } catch (error) {
    throw error;
  }
});